import React, { useState, useEffect, useRef } from "react";
import { CSVLink } from "react-csv";
import { ScrollContainer } from "react-indiana-drag-scroll";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import config from "../../config";
import Paginator from "../../shared/Paginator";
import { useDispatch, useSelector } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import AsyncSelect from 'react-select/async';
import CryptoJS from "crypto-js";
import {
  formatDate,
  formatDateToReadable,
  formatDateWithTime,
  formatDateYYYYMMDD,
  NEWISODateString,
} from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { debounce, debouncePromise } from "../../utils/Debounce";
import { formatAmount, roles, slotPaymentTypeOptions } from "../../utils/constants";
import {
  SlDrawer,
  SlButton,
  SlInput,
  SlIcon,
  SlSelect,
  SlOption,
  SlTooltip
} from "@shoelace-style/shoelace/dist/react";
import { toast } from "react-toastify";
import Stepper from "react-stepper-horizontal";
import Select from "react-select";
import { SlTabGroup, SlTab } from "@shoelace-style/shoelace/dist/react";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import PdfViewer from "./PdfViewer";
import CompanyDetails from "./CompanyDetails";
import AssignOrder from "./AssignOrder";
import InvoiceUpdate from "./InvoiceUpdate";
import OrderLogs from "./OrderLogs";
import filterSvg from "../../assets/images/filter.svg"
import { setSalesOpsOrder } from "../../redux/counterSlice";
import SlotVIew from "../salesBooking/SlotVIew";
import OrderEditLogs from "./OrderEditLogs";
import { registerSW } from "../../utils/pushSubscription";
import PackageOrder from "./PackageOrder";
import ZonePacakge from "./ZonePacakge";
import OrderDetails,{subFormInitialValues} from './OrderDetails'
import addIcon from "../../assets/images/addIcon.svg";
import OrderPdf from './OrderPdf.js'
import { flushSync } from "react-dom";
import MultiOrder from "./MultiOrder.js";
// development
// const socket = io.connect("http://localhost:4040");
// production
// const socket = io.connect();
// import {socket} from '../../socket'

const initialState = {
  ro_no: "",
  order_value: 0,
  order_name: "",
  o_start_date: "",
  o_end_date: "",
  company_id: -1,
  rofile_url: "",
  sdcfile_url: "",
  cheque_no: "",
  payment_type: 0,
  amount:0,
 
};

const addOrderSchema = Yup.object().shape({
  order_name: Yup.string().required("Order Name is Required"),
  ro_no: Yup.string().optional(),
  // advertiser_name: Yup.string().required('Advertiser is required'),
  o_start_date: Yup.date().required("Start Date is reqired"),
  o_end_date: Yup.date()
    .required("End Date is required")
    .min(Yup.ref("o_start_date"), "End date can't be before Start date"),
  company_id: Yup.number().positive().required("company is required"),
  order_value: Yup.number().positive().required("Order Value is required!"),
  rofile_url: Yup.string().optional().nullable(),
  sdcfile_url: Yup.string().optional().nullable(),
  payment_type: Yup.number()
    .required("Payment type is required!")
    .min(1, "Payment type is required")
    .max(4, "Payment type is required"),
  cheque_no: Yup.string().optional(),
  amount:Yup.number().optional(),
 
  });

function Order() {
  const dispatch = useDispatch();
  dispatch(SetComponentId(24));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const navigate = useNavigate();
  useEffect(() => {
    setCurrentDate(NEWISODateString().slice(0, 10));
    registerSW();
  }, []);

  const [company, setCompany] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentDate, setCurrentDate] = useState("");
  const HeaderSearch = useSelector((state) => state.Head.adssearch);
  const [fileUrl, setFileUrl] = useState("");
  const [fileUrl1, setFileUrl1] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const [salesList, setSaleslist] = useState([]);
  const [orderName, setOrderName] = useState("");
  const [showLineItem, setShowLineItem] = useState(false);
  const [companyId, setCompanyId] = useState();
  const OpsSales = useSelector((state) => state.Head.opssales);
  const Headdate = useSelector((state) => state.Head.date);
  const orderStatus = useSelector((state) => state.Head.orderStatus);
  const [all, setAll] = useState(localStorage.getItem('role') === roles.financer || false);
  const [progress, setProgress] = useState(0);
  const [progress1, setProgress1] = useState(0);
  const [salesTable, setSalesTable] = useState([]);
  const [headViewData, setHeadViewData] = useState({});
  const [headViewMonthFlag, setHeadViewMonthFlag] = useState("");
  const [verifiedStatus, setVerifiedStatus] = useState("all");
  const [paymentStatus, setPaymentStatus] = useState("all");
  
  const [invoiceStatus, setInvoiceStatus] = useState("all");
  const [viewPdf, setViewPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [showCompany, setShowCompany] = useState(false);
  const [assignShow, setAssignShow] = useState(false);
  const [countData, setCountData] = useState();
  const [invoiceCountData, setInvoiceCountData] = useState();
  const [assignedAdvertisers, setAssignedAdvertisers] = useState();
  const [roStatus, setRoStatus] = useState("all");
  const [rejectReason, setRejectReason] = useState(false);
  const [advertiserOrderPermissions, setAdvertiserOrderPermissions] = useState([]);
  const [showInvoice, setShowInvoice] = useState(false)
  const [order_status, setorder_status] = useState()
  const [showLogs, setShowLogs] = useState(false)
  const [oStatus, setOStatus] = useState(undefined)
  const [initialRender, setInitialRender] = useState(true)
  const [showFilter, setShowFilter] = useState(false)
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const [slotView_id, setSlotView_id] = useState(null);
  const [orderEditLogsId, setOrderEditLogsId] = useState(null)
  const [packageValue, setPackageValue] = useState(0)
  const [packageDetails,setPackageDetails] = useState({})
  const [packageStatus, setPackageStatus] = useState("all")
  const [disablePackage, setDisablePackage] = useState(false)
  const [disablePackgeCreation, setDisablePackgeCreation] = useState(false)
  const [selectedSalesId, setSelectedSalesId] = useState(null)
  const [selectedSalesType, setSelectedSalesType] = useState(null)
  const [packageOrderCount,setpackageOrdercount] = useState([]);
  const [updatedPackageValue, setUpdatedPackageValue] = useState(0)
  const [formikBSubFormValues, setFormikBSubFormValues] = useState([
    { ...subFormInitialValues, internal_id: 0 },
  ]);
  const [formikBSubFormErrors, setFormikBSubFormErrors] = useState([]);
  const [formikBTouchedFlag, setFormikBTouched] = useState(false);
  const [formikBSaveFlag, setFormikBSaveFlag] = useState(false);
  const [showSalesOrder, setShowSalesOrder] = useState(false)
  const [salesOrderData, setSalesOrderData] = useState({})
  const [assignedBrands, setAssignedBrands] = useState([])
  const [cashfreePaymentLinkDetails, setCashfreePaymentLinkDetails] = useState({})
  const [addCashfreePaymentLinkId, setAddCashfreePaymentLinkId] = useState("")
  const [paymentLinkIdOptions, setPaymentLinkIdOptions] = useState([])
  const [showMultiOrder, setShowMultiOrder] = useState(false)
  // const [editPaymentOpdId, setEditPaymentOpdId] = useState(null)
  // const [editPaymentLinkId, setEditPaymentLinkId] = useState(null)

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  const loadCompany = async () => {
    try {
      const response = await api({
        url: `/order/fetch-companies`,
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (response?.data) {
        setCompany(response?.data);
      }
    } catch (error) {
      console.log("error");
    }
  };

  const [show, setShow] = useState(false);
  const [flag, setFlag] = useState("");
  const [amid, setAmid] = useState("");

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const paymentOptions = [
    { label: "Pending", value: 0 },
    { label: "Partially Paid", value: 1 },
    { label: "Finished", value: 2 },
    { label: "Settlement", value: 3 },
  ]
  const updateNotifier = (type, order_name) => {
    let message = "";
    if (type === "new-order") message = "New order Created";
    else if (type === "invoice") message = "Invoice wa updated";
    else if (type === "payment-satus") message = "Payment status was updated";
    else if (type === "payment-stage") message = "Payment stage was updated";
    else if (type === "update-order") message = "Order was updated";
    else if (type === "pause") message = "Order was passed";
    else if (type === "resume") message = "Order was resumed";
    else if (type === "stop") message = "Order was Completed";
    else if (type === "verify") message = "Order was verified";
    // socket.emit("order_update", {
    //   message: message,
    //   order_id: amid,
    //   order_name: order_name,
    //   user: localStorage.getItem("name"),
    // });
    // socket.off("order_update")
  };

 

  const handleShow = async (choose, item) => {
    if (choose === "create") {
      // formik.setValues(item);
      setShow(true);
    }
    if (choose === "add") {
      setShow(true);
      setPackageDetails({})
      setPackageValue(0)
      setDisablePackage(false)
      setDisablePackgeCreation(false)
    }
    if (choose === "edit") {
      setFileUrl(item.rofile_url);
      setFileUrl1(item.sdcfile_url);
      let initialValues = {};
      initialValues.order_name = item.order_name;
      initialValues.ro_no = item.ro_no;
      initialValues.o_start_date = formatDateYYYYMMDD(item.o_start_date);
      initialValues.o_end_date = formatDateYYYYMMDD(item.o_end_date);
      initialValues.company_id = item.company_id;
      initialValues.payment_type = `${item.payment_type}`;
      initialValues.order_value = item.order_value;
      initialValues.rofile_url = item.rofile_url ? item.rofile_url : "";
      initialValues.sdcfile_url = item.sdcfile_url? item.sdcfile_url : "";
      initialValues.cheque_no = item.payment_details?.cheque_no;
      initialValues.amount = item.payment_details?.amount;


      let initialValues2 = {};
      initialValues2.sales_id = item.sales_id;
      setSelectedSalesId(item.sales_id)
      initialValues2.split_sales_id = item.split_sales_id;
      initialValues2.split_sales_percent = item.split_sales_percent;
      initialValues2.internal = item.internal
      initialValues2.gst = item.gst
      initialValues2.package_order = item.ispackage;
      initialValues2.brand_id = item.brand_id


      let initialValues3 = {}
      initialValues3.package_type = item.package_type || ""
      initialValues3.lang_ids = item.lang_id || []
      initialValues3.state_ids = item.state_id || []
      initialValues3.district_ids = item.district_id || []
      initialValues3.constituency_ids = item.constituency_id || []
      initialValues3.creative_type = item.creative_type || ""
      initialValues3.position = item.position || ""
      initialValues3.package_weeks = item.package_weeks || ""
      initialValues3.picked_package = item.picked_package || null
      initialValues3.zone_ids = item.zone_ids || []
      setPackageDetails(initialValues3)
      setUpdatedPackageValue(item.order_value)
      await loadCompany();
      formik.setValues(initialValues);
      formik1.setValues(initialValues2);
      await getSales();
      setShow(true);
    }
  };

  const [data, setData] = useState([]);
  const getCountByPaymentStatus = (paymentStatus) => {
    const result = countData?.find(
      (item) => item.payment_status === paymentStatus
    );

    return result ? result.count : 0;
  };

  const getCountByInvoiceStatus = (invoiceStatus) => {
    const result = invoiceCountData?.find(
      (item) => item.invoice === invoiceStatus
    );
    return result ? result.count : 0;
  }
  const getCountByPackageStatus = (ispackage) =>{
    const result = packageOrderCount?.find(
      (item) => item.ispackage === ispackage
    );
    return result ? result.count : 0;
  }
  const loadData = async (searchString = "", page = 0) => {
    setLoader(true);
    const response = await api({
      url: `/order/fetch-orders`,
      method: "POST",
      responseType: "json",
      data: {
        OpsSales : all ? OpsSales : "",
        all,
        page,
        dateFilter: Headdate,
        limit: config.PER_PAGE,
        search: searchString,
        verified: verifiedStatus,
        payment: paymentStatus,
        invoice: invoiceStatus,
        status: orderStatus,
        roStatus: roStatus,
        package_status: packageStatus,
      },
    });
    if (response?.code === 200) {
      setData(response?.data?.data);
      setTotalPages(Math.ceil(response.data.total / config.PER_PAGE));
      setCountData(response.data.counts);
      setInvoiceCountData(response.data.invoiceCounts);
      setpackageOrdercount(response.data?.packageCounts);
      setAdvertiserOrderPermissions(response?.data?.tableColumns)
      setLoader(false);
    } else {
      toast.error(response?.data?.message);
      setLoader(false);
    }
  };

  const loadBrands = async(sales_id)=>{
    try {
      let res = await api({
        url:'/order/fetch-brands',
        method:'POST',
        responseType:'json',
        data:{
          sales_id
        }
      })
      if(res.code === 200){
        setAssignedBrands(res.data)
      }
    } catch (error) {
      console.error(error)
      setAssignedBrands([])
    }
  }



  const handleClose = () => {
    setShow(false);
    formik.resetForm();
    formik1.resetForm();
    setCurrentStep(0);
    setAmid("");
    setFileUrl("");
    setFileUrl1("");
    setDisablePackage(false)
    setDisablePackgeCreation(false)
    setUpdatedPackageValue(0)
    setPackageDetails({})
    setPackageValue(0)
    setFormikBSubFormValues([
      { ...subFormInitialValues, internal_id: 0 },
    ])
    setAssignedBrands([])
    setSalesOrderData({})
  };

  const handleRoStatus = (e) => {
    setRoStatus(e.target.value);
  };

  const handlePaymentSelectStatus = (e) => {
    setPaymentStatus(e.target.value);
  }
  const handleLineItem = () => {
    setShowLineItem(false);
    setAmid("");
  };

  const downloadPdf = async (url, fileName) => {
    const pdfUrl = url;

    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const fileType = pdfUrl.split('.').pop();
      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}_ro.${fileType}`;

      // Append the link to the body
      document.body.appendChild(link);

      // Trigger a click on the link to start the download
      link.click();

      // Remove the link from the body after the download is complete
      document.body.removeChild(link);
    } catch (error) {
      Toast('error', 'Error downloading PDF');
      console.error("Error downloading PDF:", error);
    }
  };

  const handleFileChange = async(e, from) => {
    if (e.target.files.length) {

      const formData = new FormData();
      formData.append("files", e.target.files[0]);
      await uploadroFile(formData, from);
    } else {
      if (flag === "edit") {
        if(from === "ro_File"){
          setFileUrl(fileUrl);
        }else{
          setFileUrl1(fileUrl1);
        }
      }else {
        if(from === "ro_File"){
          setFileUrl("");
        }else{
          setFileUrl1("");
        }
      }
    }
  };

  // const handleVerify = async (order_id) => {
  //   try {
  //     let res = await api({
  //       url: "/order/verify-order",
  //       method: "POST",
  //       responseType: "json",
  //       data: {
  //         order_id,
  //         status:1
  //       },
  //     });

  //     if (res.code === 200) {
  //       loadData();
  //       Toast("success", "Verification Successfull");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const uploadroFile = async (formData, from) => {
    try {
      let res = await api({
        url: "/upload/file-upload",
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          if(from === "rofile"){
            setProgress(Math.round((100 * data.loaded) / data.total));
          }
          else{
            setProgress1(Math.round((100 * data.loaded) / data.total));
          }
        },
      });
      if (res.code === 200) {
        if(from === "ro_File"){
          setFileUrl(res.data?.data);
        }else{
          setFileUrl1(res.data?.data);

        }
        Toast("success", "File uploaded successfully");
      }
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    Header();
  }, [HeaderSearch]);

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
  };


  const getSales = async (department_id) => {
    try {
      let res = await api({
        url: "/user/sales_persons/getSalesByDepartment",
        method: "POST",
        responseType: "json",
        data: {
          department_id,
        },
      });
      setSaleslist(res.data);
      return res.data;
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const defaultValue = (options, value) => {
    return options ? options.filter((option) => option.value === value) : "";
  };
  const hasErrors = formikBSubFormErrors.some(
    (errObj) => Object.keys(errObj).length > 0
  );
  let formik = useFormik({
    initialValues: initialState,
    validationSchema: addOrderSchema,
    onSubmit: async (values) => {
      if (flag !== "edit") {
        try {
          let res = await api({
            url: "/order/create-order",
            method: "POST",
            responseType: "json",
            data: {
              order_name: values.order_name,
            },
          });
          if (res.status === 400) {
            setCurrentStep((prevStep) => prevStep + 1);
            await getSales();
          } else {
            Toast("error", "Order Name already taken");
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        setCurrentStep((prevStep) => prevStep + 1);
        await getSales();
      }
    },
  });

  let formik1 = useFormik({
    initialValues: {
      sales_id: "",
      split_sales_id: 0,
      split_sales_percent: 0,
      internal: false,
      gst:false,
      package_order:0,
   
    },
    validationSchema: Yup.object({
      sales_id: Yup.number().required("Sales person Name is required"),
      split_sales_id: Yup.number(),
      brand_id:Yup.number().nullable(true),
      split_sales_percent: Yup.number().when("split_sales_id", {
        is: (split_sales_id) => split_sales_id,
        then: Yup.number()
          .required("Commission is required")
          .min(1, "Must be greater than or equal to 1")
          .max(100, "Must be less than or equal to 100"),
      }),
      internal: Yup.boolean(),
      gst:Yup.boolean(),
      package_order:Yup.number()
    }),
    validateOnChange: true,
    onSubmit: async (values) => {
      flushSync(() => {
        setFormikBSaveFlag(prev => !prev);
      });
      await new Promise(resolve => setTimeout(resolve, 500));
      values.dept = undefined;
      formik.values.rofile_url = fileUrl;
      formik.values.sdcfile_url = fileUrl1;
      if(formik1.values.package_order && !packageDetails?.package_type)
      {
        Toast("error","please select package type")
        return;
      }
      if(formik1.values.package_order && !packageValue){
        Toast("error", "Please select package value")
        return
      }
      if(formik1.values.package_order){
        formik.values.order_value = updatedPackageValue
      }
      if(!formik1.values.package_order && hasErrors){
        Toast("error", "Please Choose order Details")
        return
      }
      if (flag === "create") {
        try {
          let res = await api({
            url: `/order/create-order`,
            method: "POST",
            responseType: "json",
            data: {
              ...values,
              ...formik.values,
              ...packageDetails,
              package_value:packageValue,
              formikBSubFormValues:formikBSubFormValues
            },
          });
          if (res?.code !== 200) {
            Toast("error", res?.data?.message);
          } else {
            handleClose();
            setCurrentPage(0);
            setSearch("");
            loadData("", 0);
            updateNotifier("new-order", formik.values.order_name);
            Toast("success", "Order Added Successfully");
            setPackageDetails({})
            setPackageValue(0)
            setUpdatedPackageValue(0)
            setDisablePackage(false)
            setDisablePackgeCreation(false)
            setFormikBSubFormValues([
              { ...subFormInitialValues, internal_id: 0 },
            ])
          }
        } catch (error) {
          Toast("error", "Something went Wrong");
        }
      }

      if (flag === "edit") {
        try {
          formik.values.ro_value = undefined;
          formik.values.order_id = amid;
          formik.values.rofile_url = fileUrl;
          formik.values.sdcfile_url = fileUrl1;
          formik.values.o_status = oStatus
          let res = await api({
            url: `/order/update-order`,
            method: "POST",
            responseType: "json",
            data: {
              ...formik.values,
              ...values,
              ...packageDetails,
              package_value:packageValue,
              formikBSubFormValues:formikBSubFormValues
            },
          });
          if (res?.code !== 200) {
            Toast("error", res?.data?.message);
          } else {
            handleClose();
            loadData(search, currentPage);
            setOStatus(undefined)
            updateNotifier("update-order", formik.values.order_name);
            Toast("success", "Order Edited Successfully");
            setPackageValue(0)
            setPackageDetails({})
            setUpdatedPackageValue(0)
            setDisablePackage(false)
            setDisablePackgeCreation(false)
            setFormikBSubFormValues([
              { ...subFormInitialValues, internal_id: 0 },
            ])
          }
        } catch (error) {
          Toast("error", "Something went wrong");
          if (error.response.status === 401) navigate("/");
        }
      }
    },
  });


  let formik3 = useFormik({
    initialValues: {
      "reason":""
    },
    validationSchema: Yup.object({
      "reason":Yup.string().required("Reason is required!")
    }),
    onSubmit: async (values) => {
     try {
      let res = await api({
        url: "/order/verify-order",
        method: "POST",
        responseType: "json",
        data: {
          order_id:amid,
          status:2,
          reason:values.reason
        },
      })
      if(res.code === 200){
        setAmid("")
        setRejectReason(false)
        loadData(search, currentPage);
        formik3.resetForm()
      }
     } catch (error) {
      console.error(error)
     }
    },
  });

  useEffect(() => {
      loadData(search, currentPage);
  }, [
    search,
    all,
    Headdate,
    verifiedStatus,
    paymentStatus,
    invoiceStatus,
    orderStatus,
    roStatus,
    currentPage,
    packageStatus
  ]);
  useEffect(() => {
    if(all){
      loadData(search, currentPage);
      dispatch(setSalesOpsOrder( OpsSales=== "" || OpsSales.index === -1 || OpsSales.index === undefined ? { index: 0, value: 0 } : OpsSales))
    }
  }, [all, OpsSales]);


  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };
  let salesUserType = "";
  if (
    localStorage.getItem("role") === roles.salesperson &&
    localStorage.getItem("salesTabFlag")
  ) {
    const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(
      localStorage.getItem("salesTabFlag"),
      config.B2B_SECRET_KEY
    );
    salesUserType = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8);
  }
  const getSalesStats = async () => {
    if (localStorage.getItem("role") === roles.salesperson) {
      try {
        let res = await api({
          url: "/lineitems/getSalesStats",
          method: "POST",
          responseType: "json",
        });
        setSalesTable(res.data);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
      setInitialRender(false)
    }
  };
  function formatSpentValue(value) {
    return formatAmount(value)
    // if (value < 1000) {
    //   return `${value}`;
    // } else if (value >= 1000 && value < 1000000) {
    //   const kValue = (value / 1000).toFixed(2);
    //   return `${kValue}K`;
    // } else if (value >= 1000000) {
    //   const mValue = (value / 1000000).toFixed(2);
    //   return `${mValue}M`;
    // } else return 0;
  }
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const HeadDetailedView = async (flag) => {
    try {
      const HeadViewResult = await api({
        url: "/user/sales_persons/headView",
        method: "POST",
        responseType: "json",
        data: { flag: flag },
      });
      setHeadViewData(HeadViewResult.data);
      setHeadViewMonthFlag(flag === "thisMonth" ? "This Month" : "Last Month");
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloneOrder = async (item) => {
    let obj = {
      order_name: `${item.order_name}_${Math.round(Date.now() / 1000)}`,
      company_id: item.company_id,
      o_end_date: formatDateYYYYMMDD(item.o_end_date),
      order_value: item.order_value,
      payment_type: item.payment_type,
      o_start_date: formatDateYYYYMMDD(item.o_start_date),
      sales_id: item.sales_id,
      ro_no: "",
      rofile_url: "",
      split_sales_id: item.split_sales_id,
      split_sales_percent: item.split_sales_percent,
      internal: item.internal,
      gst:item.gst,
      package_order:item.ispackage,
      package_type:item.picked_package,
      lang_ids: item.lang_id,
      state_ids: item.state_id,
      district_ids: item.district_id,
      constituency_ids: item.constituency_id,
      creative_type: item.creative_type,
      position: item.position,
      package_weeks: item.package_weeks,
      pacakge_value:item.pacakge_value,
      salesType:item.package_type,
      zone_ids:item.zone_ids || [],
      formikBSubFormValues:item.formikbsubformvalues || []
    };
    try {
      let res = await api({
        url: "/order/create-order",
        method: "POST",
        responseType: "json",
        data: obj,
      });
      if (res.code === 200) {
        loadData();
        updateNotifier("new-order", obj.order_name);
        Toast("success", "Order Clonned Successfully!");
      } else {
        Toast("error", "Please try again!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if(initialRender)
      getSalesStats();
  }, [OpsSales]);

  const handleOrderOperations = async (order_id, mode) => {
    try {
      let res = await api({
        url: "/order/handle-operation",
        method: "POST",
        responseType: "json",
        data: {
          order_id: order_id,
          mode: mode,
        },
      });
      if (res.code === 200) {
        if (mode === 3) updateNotifier("stop", orderName);
        Toast("success", "Updated Successfully");
        loadData(search, currentPage);
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const csvLinkRef = useRef(); // Create a ref for CSVLink
  let csvHeaders = [
    { label: "Order Id", key: "order_id" },
    { label: "Order Name", key: "order_name" },
    { label: "Order Value", key: "order_value" },
    { label: "Company Name", key: "company_name" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },
    { label: "Impressions", key: "imps" },
    { label: "Clicks", key: "clicks" },
    { label: "Spent", key: "total_spent" },
    { label: "Created Date", key: "createdDate" },
    { label: "CST Name", key: "ops_name" },
    { label: "Sales Name", key: "sales_name" },
    { label: "Order Status", key: "orderStatus" },
    { label: "Ro Url", key: "rofile_url" }
];
if(localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops){
  csvHeaders.push({ label: "Filtered Impressions", key: "filter_imps" },)
  csvHeaders.push({ label: "Filtered Clicks", key: "filter_clicks" },)
  csvHeaders.push({ label: "Filtered Spent", key: "filterSpent" },)
}
if(localStorage.getItem("role") === roles.ops){
  csvHeaders.push({ label: "ADV Impressions", key: "adv_imps" },)
  csvHeaders.push({ label: "ADV Clicks", key: "adv_clicks" },)
  csvHeaders.push({ label: "Adv Spent", key: "adv_spent" },)
}
const downloadReport = async (searchString
) => {
    setDownloadLoader(true);
    try {
  let result = await api({
      url: "/order/ordersReportDownload",
      method: "POST",
      responseType: "json",
      data: {
        OpsSales : all ? OpsSales : "",
        all,
        dateFilter: Headdate,
        search: searchString,
        verified: verifiedStatus,
        payment: paymentStatus,
        invoice: invoiceStatus,
        status: orderStatus,
        roStatus: roStatus,
      },
  });
  if (result?.code === 200) {
      setDownloadLoader(false);
      setDownloadData(result.data.data);
  }
    } catch (error) {
  setDownloadLoader(false);
  console.error(error);
  if (error.response.status === 401) navigate("/");
    }
};
useEffect(() => {
  if (downloadData.length) {
      csvLinkRef?.current?.link?.click();
      setDownloadData([]);
  }
}, [downloadData]);

  const steps = [{ title: "Order Details" }, { title: "Sales Details" }];
  useEffect(() => {
    if(amid){
  async  function fetchLineitemsCount () {
      const res = await api({
        url: `/order/getLineitemsCount`,
        method: 'POST',
        responseType: 'json',
        data: { orderId:amid }
      });
      if(res.code === 200){
        if(res.data.package_count > 0){
          setDisablePackage(true)
      }
      if(res.data.normal_count > 0){
        setDisablePackgeCreation(true)
      }
     }
    }
    fetchLineitemsCount();
  }
  }, [amid]);

useEffect(()=>{
  if(selectedSalesId && salesList.length > 0){
   let userType = salesList.filter(item => item.value === selectedSalesId)
   if(userType[0]?.new_user_type === 5){
  setSelectedSalesType("Alpha")
   }
   else if(userType[0]?.new_user_type === 9){
    setSelectedSalesType("Inbound")
     }
   else if(userType[0]?.new_user_type === 2){
    setSelectedSalesType("Local")
     }
   else{
    setSelectedSalesType(null)
   }
  }
},[selectedSalesId, salesList])
useEffect(()=>{
  loadBrands(formik1.values.sales_id)
},[formik1.values.sales_id])

  const getCashfreePaymentLinks = async(order_id) => {
    setCashfreePaymentLinkDetails({order_id, loading: true})
    try {
      let res = await api({
        url: "/order/get-payment-links",
        method: "POST",
        responseType: "json",
        data: { order_id }
      })
      if(res.code === 200){
        setCashfreePaymentLinkDetails({order_id, loading: false, paymentArray: res.data?.paymentLinks || []})
      }else{
        setCashfreePaymentLinkDetails({order_id, loading: false})
      }
    } catch (error) {
      console.error(error)
      setCashfreePaymentLinkDetails({order_id, loading: false})
      console.error("Error getCashfreePaymentLinks", error)
    }
  }
  const addCashfreePaymentLink = async(link_id, order_id) => {
    try {
      let res = await api({
        url: "/order/add-payment-link-to-order",
        method: "POST",
        responseType: "json",
        data: { link_id, order_id }
      })
      if(res.code === 200){
        Toast("success", "Payment link added successfully")
        getCashfreePaymentLinks(order_id)
        setAddCashfreePaymentLinkId("")
        setPaymentLinkIdOptions([])
      }else{
        Toast("error", res.data?.message || res.message || "Failed to add payment link")
      }
    }
    catch (error) {
      console.error("Error addPaymentLink", error)
    }
  }
  const fetchCashfreeLinkIdOptions = async(searchString) => {
    try {
      let res = await api({
        url: "/order/get-payment-link-id-options",
        method: "POST",
        responseType: "json",
        data: { searchString }
      })
      if(res.code === 200){
        setPaymentLinkIdOptions(res.data || [])
        return res.data || []
      }else{
        setPaymentLinkIdOptions([])
        return []
      }
    } catch (error) {
      console.error("Error fetchCashfreeLinkIdOptions", error)
      setPaymentLinkIdOptions([])
      return []
    }
  }


  const debouncedFetchCashfreeLinkIdOptions = debouncePromise(fetchCashfreeLinkIdOptions, 500); // Adjust the delay as needed

  const loadOrdersFromMulti = ()=>{
    loadData("", 0)
    setCurrentPage(0)
    setSearch("")
    setShowMultiOrder(false)
  }

  return (
    <>
      <div class="row">
        <div className={"table-responsive col-md-12 mb-2"}>
          {
            //new Dashboard
            localStorage.getItem("role") === roles.salesperson &&
            Object.keys(salesTable).length ? (
              <table className="table table-bordered table-pad-sm ">
                <thead className="bg-neutral-50">
                  <tr>
                    <th></th>
                    <th>I/O Received</th>
                    <th>Delivered</th>
                    <th>Target</th>
                    <th>achieved</th>
                    <th>Rank</th>
                    <th>Orders</th>
                    <th>Avg</th>
                    {salesUserType && <></>}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>This Month</td>
                    <td>
                      {" "}
                      {salesTable.ThisMonthRoCPD < salesTable.lastMonthRoCPD ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.ThisMonthRoCPD)}`}
                        </span>
                      ) : salesTable.ThisMonthRoCPD >
                        salesTable.lastMonthRoCPD ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.ThisMonthRoCPD)}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.ThisMonthRoCPD)}`
                      )}
                    </td>
                    <td>
                      {salesTable.thisMonthDelivered <
                      salesTable.lastMonthDelivered ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(
                            salesTable.thisMonthDelivered
                          )}`}
                        </span>
                      ) : salesTable.thisMonthDelivered >
                        salesTable.lastMonthDelivered ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(
                            salesTable.thisMonthDelivered
                          )}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.thisMonthDelivered)}`
                      )}
                    </td>
                    <td>
                      {salesTable.thisMonthTarget <
                      salesTable.lastMonthTarget ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.thisMonthTarget)}`}
                        </span>
                      ) : salesTable.thisMonthTarget >
                        salesTable.lastMonthTarget ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.thisMonthTarget)}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.thisMonthTarget)}`
                      )}
                    </td>

                    <td>
                      {salesTable.thisMonthAchieved <
                      salesTable.lastMonthAchieved ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.thisMonthAchieved)}`}
                        </span>
                      ) : salesTable.thisMonthAchieved >
                        salesTable.lastMonthAchieved ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.thisMonthAchieved)}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.thisMonthAchieved)}`
                      )}
                    </td>
                    <td>
                      {salesTable.ThisMonthRank < salesTable.lastMonthRank ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`${
                            salesTable.ThisMonthRank
                              ? salesTable.ThisMonthRank
                              : "-"
                          }`}
                        </span>
                      ) : salesTable.ThisMonthRank >
                        salesTable.lastMonthRank ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`${
                            salesTable.ThisMonthRank
                              ? salesTable.ThisMonthRank
                              : "-"
                          }`}
                        </span>
                      ) : (
                        `${
                          salesTable.ThisMonthRank
                            ? salesTable.ThisMonthRank
                            : "-"
                        }`
                      )}
                    </td>
                    <td>
                      {" "}
                      {salesTable.ThisMonthCampaignsCount <
                      salesTable.LastMonthCampaignsCount ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {salesTable.ThisMonthCampaignsCount}
                        </span>
                      ) : salesTable.ThisMonthCampaignsCount >
                        salesTable.LastMonthCampaignsCount ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {salesTable.ThisMonthCampaignsCount}
                        </span>
                      ) : (
                        salesTable.ThisMonthCampaignsCount
                      )}
                    </td>
                    <td>
                      {salesTable.thisMonthAvg < salesTable.lastMonthAvg ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`${salesTable.thisMonthAvg}`}
                        </span>
                      ) : salesTable.thisMonthAvg > salesTable.lastMonthAvg ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`${salesTable.thisMonthAvg}`}
                        </span>
                      ) : (
                        `${salesTable.thisMonthAvg}`
                      )}
                    </td>
                    {salesUserType && (
                      <td>
                        <sl-tooltip content="View" hoist>
                          <sl-icon-button
                            library="lucide"
                            name="eye"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => {
                              HeadDetailedView("thisMonth");
                            }}
                          ></sl-icon-button>
                        </sl-tooltip>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td>Last Month</td>
                    <td>
                      {" "}
                      {salesTable.lastMonthRoCPD < salesTable.ThisMonthRoCPD ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.lastMonthRoCPD)}`}
                        </span>
                      ) : salesTable.lastMonthRoCPD >
                        salesTable.ThisMonthRoCPD ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.lastMonthRoCPD)}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.lastMonthRoCPD)}`
                      )}
                    </td>
                    <td>
                      {salesTable.lastMonthDelivered <
                      salesTable.thisMonthDelivered ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(
                            salesTable.lastMonthDelivered
                          )}`}
                        </span>
                      ) : salesTable.lastMonthDelivered >
                        salesTable.thisMonthDelivered ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(
                            salesTable.lastMonthDelivered
                          )}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.lastMonthDelivered)}`
                      )}
                    </td>
                    <td>
                      {salesTable.lastMonthTarget <
                      salesTable.thisMonthTarget ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.lastMonthTarget)}`}
                        </span>
                      ) : salesTable.lastMonthTarget >
                        salesTable.thisMonthTarget ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.lastMonthTarget)}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.lastMonthTarget)}`
                      )}
                    </td>
                    <td>
                      {salesTable.lastMonthAchieved <
                      salesTable.thisMonthAchieved ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.lastMonthAchieved)}`}
                        </span>
                      ) : salesTable.lastMonthAchieved >
                        salesTable.thisMonthAchieved ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`₹${formatSpentValue(salesTable.lastMonthAchieved)}`}
                        </span>
                      ) : (
                        `₹${formatSpentValue(salesTable.lastMonthAchieved)}`
                      )}
                    </td>
                    <td>
                      {salesTable.lastMonthRank < salesTable.ThisMonthRank ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`${
                            salesTable.lastMonthRank
                              ? salesTable.lastMonthRank
                              : "-"
                          }`}
                        </span>
                      ) : salesTable.lastMonthRank >
                        salesTable.ThisMonthRank ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`${
                            salesTable.lastMonthRank
                              ? salesTable.lastMonthRank
                              : "-"
                          }`}
                        </span>
                      ) : (
                        `${
                          salesTable.lastMonthRank
                            ? salesTable.lastMonthRank
                            : "-"
                        }`
                      )}
                    </td>
                    <td>
                      {" "}
                      {salesTable.LastMonthCampaignsCount <
                      salesTable.ThisMonthCampaignsCount ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {salesTable.LastMonthCampaignsCount}
                        </span>
                      ) : salesTable.LastMonthCampaignsCount >
                        salesTable.ThisMonthCampaignsCount ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {salesTable.LastMonthCampaignsCount}
                        </span>
                      ) : (
                        salesTable.LastMonthCampaignsCount
                      )}
                    </td>

                    <td>
                      {salesTable.lastMonthAvg < salesTable.thisMonthAvg ? (
                        <span style={{ color: "red" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-down"
                            className="mr-1"
                          ></SlIcon>
                          {`${salesTable.lastMonthAvg}`}
                        </span>
                      ) : salesTable.lastMonthAvg > salesTable.thisMonthAvg ? (
                        <span style={{ color: "green" }}>
                          <SlIcon
                            library="lucide"
                            name="arrow-up"
                            className="mr-1"
                          ></SlIcon>
                          {`${salesTable.lastMonthAvg}`}
                        </span>
                      ) : (
                        `${salesTable.lastMonthAvg}`
                      )}
                    </td>
                    {salesUserType && (
                      <td>
                        <sl-tooltip content="View" hoist>
                          <sl-icon-button
                            library="lucide"
                            name="eye"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => {
                              HeadDetailedView("lastMonth");
                            }}
                          ></sl-icon-button>
                        </sl-tooltip>
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            ) : (
              ""
            )
          }
        </div>
      </div>
      {localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson ? (
        <>
       <div className="invoice-radios flex gap-3 flex-wrap sticky top-0 w-full bg-white py-2 z-10">
            <div className="d-flex gap-2.5 flex-wrap invoice-radios-list mobHide">
                <div class="custom-invoice-radio">
                  <input
                    type="radio"
                    id="ide1"
                    value={'all'}
                    name="invoice"
                    onClick={()=>{
                      setInvoiceStatus("all")
                    }}
                    checked={invoiceStatus === "all"}
                  />
                  <label for="ide1" className="rounded-full">
                    <span>{`All`}</span>
                  </label>
                </div>
                <div class="custom-invoice-radio">
                  <input
                    type="radio"
                    id="ide2"
                    name="invoice"
                    value={'0'}
                    onChange={()=>{
                      setInvoiceStatus("0")
                    }}
                    checked={invoiceStatus === "0"}

                  />
                  <label for="ide2" className="rounded-full">
                    <span>{`No Invoice ${getCountByInvoiceStatus(false)}`}</span>
                  </label>
                </div>
                <div class="custom-invoice-radio">
                  <input
                    type="radio"
                    id="ide3"
                    name="invoice"
                    value={'1'}
                    onChange={()=>{
                      setInvoiceStatus("1")
                    }}
                    checked={invoiceStatus === "1"}
                  />
                  <label for="ide3" className="rounded-full">
                    <span>{`Invoice ${getCountByInvoiceStatus(true)}`}</span>
                  </label>
                </div>
               
              </div>
              <div className="d-flex gap-2.5 flex-wrap payment-radios mobHide">
              <div class="custom-invoice-radio">
             <input
               type="radio"
               id="ide1"
               name="invoice-status"
               value={'all'}
               onChange={()=>{
                 setPaymentStatus("all")
               }}
               checked={paymentStatus === "all"}

             />
             <label for="ide1" className="rounded-full">
               <span>{`All`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               id="ide1"
               name="invoice-status"
               value={'0'}
               onChange={()=>{
                 setPaymentStatus("0")
               }}
               checked={paymentStatus === "0"}

             />
             <label for="ide1" className="rounded-full">
               <span>{`Pending ${getCountByPaymentStatus(0)}`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               name="invoice-status"
               id="ide2"
               value={'1'}
               onChange={() =>{
                 setPaymentStatus("1")
               }}
               checked={paymentStatus === "1"}

             />
             <label for="ide2" className="rounded-full">
               <span>{`Partially Paid ${getCountByPaymentStatus(1)}`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               name="invoice-status"
               id="ide3"
               value={'2'}
               onChange={
                () =>{
                   setPaymentStatus("2")
               }
              }
               checked={paymentStatus === "2"}

             />
             <label for="ide3" className="rounded-full">
               <span>{`Finished ${getCountByPaymentStatus(2)}`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               name="invoice-status"
               id="ide4"
               value={'3'}
               onChange={()=>{
                   setPaymentStatus("3")
               }}
               checked={paymentStatus === "3"}

             />
             <label for="ide4" className="rounded-full">
               <span>{`Settlement ${getCountByPaymentStatus(3)}`}</span>
             </label>
           </div>
         </div>
         {/* <div className="d-flex gap-2.5 flex-wrap package-radios mobHide">
              <div class="custom-invoice-radio">
             <input
               type="radio"
               id="package1"
               name="package_status"
               value={'all'}
               onChange={()=>{
                 setPackageStatus("all")
               }}
               checked={packageStatus === "all"}

             />
             <label for="package1" className="rounded-full">
               <span>{`All`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               id="package2"
               name="package_status"
               value={'0'}
               onChange={()=>{
                 setPackageStatus("0")
               }}
               checked={packageStatus === "0"}

             />
             <label for="package2" className="rounded-full">
               <span>{`No Package ${getCountByPackageStatus(0)}`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               name="package_status"
               id="package3"
               value={'1'}
               onChange={() =>{
                 setPackageStatus("1")
               }} 
               checked={packageStatus === "1"}

             />
             <label for="package3" className="rounded-full">
               <span>{`Package ${getCountByPackageStatus(1)+getCountByPackageStatus(2)}`}</span>
             </label>
           </div>
           
         </div> */}
         <aside className="ml-auto flex align-items-end gap-3 mr-2 mobHide">
          <div>
            <SlSelect
              label="Ro"
              size="small"
              value={roStatus}
              onSlChange={handleRoStatus}
            >
              <SlIcon library="lucide" name="file" slot="prefix"></SlIcon>
              <SlOption key="all" value="all">
                All
              </SlOption>
              <SlOption key="1" value="1">
                Ro
              </SlOption>
              <SlOption key="0" value="0">
                No Ro
              </SlOption>
            </SlSelect>
          </div>
          <div>
            <SlInput
              label="Search"
              size="small"
              id="myInput"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search by Order Name/Company"
            >
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
          </div>
          
        </aside>
        <div className="d-flex items-center ml-auto gap-3 justify-end mt-5">
          <h6 className="mobileOnly">Orders</h6>
        <img src={filterSvg} onClick={() => setShowFilter(true)} alt="filter" className="w-6 mobileOnly"></img>
        {localStorage.getItem("role") === roles.ops && (
            <div className="flex gap-3 items-center">
              <SlButton size="small"
                variant="primary"
                onClick={() => {
                  setShowMultiOrder(true)
                  getSales()
                  loadCompany()
                }}
              >
                Multi Order
              </SlButton>
              <SlButton
                size="small"
                variant="primary"
                onClick={() => {
                  handleShow("create", {});
                  setFlag("create");
                  loadCompany();
                }}
              >
                New Order
              </SlButton>
            </div>
          )}
          {(localStorage.getItem('role') === roles.ops || localStorage.getItem('role') === roles.financer) &&<div className="ml-auto">
          <CSVLink
              data={downloadData.map(
                  ({
                    order_id,
                    order_name,
                    order_value,
                    company_name,
                    total_spent,
                    adv_spent,
                    o_start_date,
                    o_end_date,
                    impclicks,
                    created_date,
                    ops_name,
                    sales_name,
                    status,
                    rofile_url
                  }) => {
                      const startDate = formatDate(o_start_date);
                      const endDate = formatDate(o_end_date);
                      const createdDate =formatDate(created_date)
                      const orderStatus = status === 0 ? (
                        'Pending'
                      ) : status === 1 ? (
                        'Running'
                      ) : status === 2 ? (
                        'Paused'
                      ) : (
                        'Completed'
                      );

                      const imps =
                      localStorage.getItem("role") === roles.ops
                              ? impclicks?.[0]?.total_imp
                                  ? impclicks?.[0]?.total_imp
                                  : 0
                              : parseInt(
                                  impclicks?.[0]?.adv_total_imp
                                      ? impclicks?.[0]?.adv_total_imp
                                      : 0
                              );
                      const clicks =
                      localStorage.getItem("role") === roles.ops
                              ? impclicks?.[0]?.total_click
                                  ? impclicks?.[0]?.total_click
                                  : 0
                              : parseInt(
                                  impclicks?.[0]?.adv_total_click
                                      ? impclicks?.[0]?.adv_total_click
                                      : 0
                              );
                      const spent =
                      localStorage.getItem("role") === roles.ops
                              ? total_spent ? parseFloat(total_spent).toFixed(2)
                                  : 0
                              : adv_spent ? parseFloat(adv_spent).toFixed(2)
                              : 0;
                     
                      let obj = {
                        order_id,
                        order_name,
                        order_value,
                        company_name,
                        startDate,
                        endDate,
                        createdDate,
                        ops_name,
                        sales_name,
                        orderStatus,
                        imps,
                        clicks,
                        total_spent: spent,
                        rofile_url,  
                      };
                      if (
                        localStorage.getItem("role") === roles.ops
                      ) {
                        obj.adv_imps = impclicks?.[0].adv_total_imp
                        obj.adv_clicks= impclicks?.[0].adv_total_click
                        obj.adv_spent= impclicks?.[0].adv_spent
                      }
                      if (
                        localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops){
                          obj.filterSpent = impclicks?.[0].filterSpent
                          obj.filter_imps = parseInt(impclicks?.[0].filter_imps || 0)
                          obj.filter_clicks = parseInt(impclicks?.[0].filter_clicks || 0)

                        }
                      return obj;
                  }
              )}
              headers={csvHeaders}
              filename={"Orders_report.csv"}
              ref={csvLinkRef} // Assign the ref to the CSVLink component
          ></CSVLink>

          {downloadLoader ? (
              <TableLoader />
          ) : (
              <SlTooltip content="Download Orders Reports">
                  <SlIcon
                      library="lucide"
                      name="download"
                      className="w-6 h-6"
                      onClick={() => {
                          downloadReport(search)
                      }}
                  ></SlIcon>
              </SlTooltip>
          )}
        </div>}
        </div>
       </div>
      </>
      ) : null}
      <div className="flex items-center">
        {/* <h5 className="mr-4">Orders</h5> */}
        {/* <aside class="flex gap-3 ml-auto"> */}

      </div>
      <SlTabGroup>
        {(localStorage.getItem("role") !== roles.financer && localStorage.getItem('role') !== roles.legalperson) && (
          <SlTab
            onClick={() => {
              setAll(false);
              dispatch(setSalesOpsOrder({ index: -1, value: -1 }))
            }}
            slot="nav"
            panel="general"
          >
            {localStorage.getItem("name")}
          </SlTab>
        )}
        {localStorage.getItem("role") !== roles.advertiser && (localStorage.getItem('role') === roles.salesperson ? salesUsersList?.length > 1 : true)&&(
          <SlTab
            onClick={() => {
              setAll(true);

            }}
            slot="nav"
            panel="all"
          >
            All
          </SlTab>
        )}
      </SlTabGroup>
      <div className="mb-1" id="orderTable">
        <ScrollContainer>
          <table className=" table table-bordered">
            <thead className="sticky top-0 ">
              <tr>
                <th width="100px">Order Id</th>
                <th width="100px">Order Name</th>
                {((localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) || (localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('order_value')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('order_value'))) ? (<th width="140px">Order Value</th>) : null}
                <th width="140px">Company Name</th>
                {((localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) || (localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('start_date')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('start_date'))) ? (<th width="140px">Start Date</th>) : null}
                {((localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) || (localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('end_date')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('end_date'))) ? (<th width="140px">End Date</th>) : null}
                {((localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('impressions')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('impressions'))) ? (<th width="140px">Impressions</th>) : localStorage.getItem('role') === roles.ops ? <th> <div>
                    <p className="my-0">Adv Impressions</p> 
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0" s>
                      Impressions
                    </p>
                  </div></th>: localStorage.getItem('role') === roles.financer ? <th width="140px">Impressions</th> : null}
                {((localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('clicks')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('clicks'))) ? (<th width="140px"> Clicks</th>) : localStorage.getItem('role') === roles.ops ? <th><div>
                    <p className="my-0">Adv Clicks</p> 
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0" s>
                      Clicks
                    </p>
                  </div></th>: localStorage.getItem('role') === roles.financer ? <th width="140px">Clicks</th> : null}
                {(localStorage.getItem("role") === roles.advertiser || localStorage.getItem("role") === roles.salesperson) && advertiserOrderPermissions?.includes('ecpm') ? (<th width="140px"> ECPM</th>) : null}
                {(localStorage.getItem("role") === roles.advertiser || localStorage.getItem("role") === roles.salesperson) && advertiserOrderPermissions?.includes('ctr') ? (<th width="140px"> CTR(%)</th>) : null}
                {( (localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('spent')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('spent'))) ? (<th width="140px">Amount Spent</th>) : localStorage.getItem('role') === roles.ops ? <th><div>
                    <p className="my-0">Adv Spent</p> 
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0" s>
                      Amount Spent
                    </p>
                  </div></th>: localStorage.getItem('role') === roles.financer ? <th width="140px">Amount Spent</th> : null}
                  {((localStorage.getItem('role') === roles.financer || localStorage.getItem('role') === roles.ops) && Headdate.startDate != null && Headdate.endDate != null) ? <><th><div>
                    <p className="my-0" s>
                      Filtered Imps
                    </p>
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0">Filtered Clicks</p>
                  </div></th>
                  <th>Filtered Spent</th></> : null}
                <th width="160px">Created Date</th>
                {(localStorage.getItem('role')!== roles.advertiser && localStorage.getItem('role') !== roles.salesperson) && <th>
                  <div>
                    <p className="my-0" s>
                      CST
                    </p>
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0">Sales Person</p>
                  </div>
                </th>}
                <th width="80px">Status</th>
                {/* {localStorage.getItem("role") !== roles.advertiser &&
                  localStorage.getItem("role") !== roles.salesperson && (
                    <th width="60px">Verified</th>
                  )} */}
                <th>Invoice</th>
                <th>Ro</th>
                {localStorage.getItem('role') === roles.ops ? <th>Sales Inputs</th> : null}
                {(localStorage.getItem("role") === roles.ops ||
                  localStorage.getItem("role") === roles.financer) && (
                  <th width="80px">Actions</th>
                )}
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item) => {
                  return (
                    <tr
                      key={item.id}
                      className={ (item.verified === 2 && (localStorage.getItem('role') === roles.ops || localStorage.getItem('role') === roles.financer))? "bg-red-100" :"group/details hover:bg-slate-100"}
                      
                    >
                      {/* <th scope='row'> </th> */}
                      {/* <td className="wgt-600">{item.ro_no}</td> */}
                      <td className={item.edit_status?.status === 1 ? "text-purple-600" : item.edit_status?.status === 2 ? 'text-red-600' : ''}>{item.order_id}{" "}
                       {item.ispackage ? <sl-icon title="Package Order" class="text-purple-600" name="gift" library="lucide"></sl-icon> : null}
                      </td>

                      {/* <td>{item.additional_amount}</td>
                                            <td>{item.additional_amount_approved_by || '-'}</td> */}
                      <td
                        className="order-link"
                        onClick={() => {
                          
                          const order = {
                              order_id:item.order_id,
                              order_type:item.order_type,
                              orderName:item.order_name,
                              company_id:item.company_id,
                              sales_person_id: item.sales_id,
                              impressionData:item.impclicks?.[0],
                              permissions:advertiserOrderPermissions,
                              ispackage:item.ispackage,
                              package_type: item.package_type,
                              new_user_type : item?.new_user_type
                            }
                          navigate(`/home/order/${item.id}`, {state:{order}});
                        }}
                      >
                        {item.order_name || "-"}
                      </td>
                      {((localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) || (localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('order_value')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('order_value'))) ? (<td>{item.order_value}</td>) : null}
                      <td
                        className={
                          localStorage.getItem("role") !== roles.advertiser &&
                          "company-name"
                        }
                        onClick={() => {
                          if (
                            localStorage.getItem("role") !== roles.advertiser
                          ) {
                            setCompanyId(item.company_id);
                            setShowCompany(true);
                          }
                        }}
                      >
                        {item.company_name}
                      </td>
                      {((localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) || (localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('start_date')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('start_date'))) ? (<td>{formatDate(item.o_start_date)}</td>) : null}
                      {((localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) || (localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('end_date')) || (localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('end_date'))) ? (<td>{formatDate(item.o_end_date)}</td>) : null}

                      {localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('impressions') ? (
                        <td>{parseInt(item?.impclicks?.[0].adv_total_imp || 0)}</td>
                      ) : localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('impressions') ? (
                        <td> {parseInt(item?.impclicks?.[0].adv_total_imp || 0)}</td>
                      ) : localStorage.getItem("role") === roles.financer ? (
                            <td>{parseInt(item?.impclicks?.[0].adv_total_imp || 0)}</td>
                      ) : localStorage.getItem('role') === roles.ops ?<td><div>
                      <p className="my-0"> {parseInt(item?.impclicks?.[0].adv_total_imp || 0)}</p> 
                      <span className="block border-b border-gray-500 border-dashed"></span>
                      <p className="my-0" s>
                      {parseInt(item?.impclicks?.[0].total_imp || 0)}
                      </p>
                    </div></td> : null}

                      {localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('clicks') ? (
                        <td>{parseInt(item?.impclicks?.[0].adv_total_click || 0)}</td>
                      ) : localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('clicks') ? (
                        <td> {parseInt(item?.impclicks?.[0].adv_total_click || 0)}</td>
                      ) : localStorage.getItem("role") === roles.financer ? (
                        <td>{parseInt(item?.impclicks?.[0].adv_total_click || 0)}</td>
                      ) : localStorage.getItem('role') === roles.ops ?<td><div>
                    <p className="my-0"> {item?.impclicks?.[0].adv_total_click || 0}</p> 
                  <span className="block border-b border-gray-500 border-dashed"></span>
                  <p className="my-0" s>
                  {parseInt(item?.impclicks?.[0].total_click || 0)}
                  </p>
                </div></td> : null}

                      {localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('ecpm') ? (
                        <td>{(item?.ecpm !== null ? item.ecpm.toFixed(2) : 0)}</td>
                      ) : localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('ecpm') ? (
                        <td>{(item?.ecpm !== null ? item.ecpm.toFixed(2) : 0)}</td>
                      ) : null}

                      {localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('ctr') ? (
                        <td>{(item?.ctr !== null ? item.ctr.toFixed(2) : 0)}</td>
                      ) : localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('ctr') ? (
                        <td>{(item?.ctr !== null ? item.ctr.toFixed(2) : 0)}</td>
                      ) : null}

                      {localStorage.getItem("role") === roles.advertiser && advertiserOrderPermissions?.includes('spent') ? (
                        <td>{item?.impclicks?.[0]?.adv_spent?.toFixed(2) || 0}</td>
                      ) : localStorage.getItem("role") === roles.salesperson && advertiserOrderPermissions?.includes('spent') ? (
                        <td> {item?.impclicks?.[0]?.adv_spent?.toFixed(2) || 0}</td>
                      ) : localStorage.getItem("role") === roles.financer ? (
                        <td>{item?.impclicks?.[0]?.adv_spent?.toFixed(2) || 0}</td>
                  ) : localStorage.getItem('role') === roles?.ops ?<td><div>
                  <p className="my-0"> {item?.impclicks?.[0]?.adv_spent?.toFixed(2) || 0}</p> 
                  <span className="block border-b border-gray-500 border-dashed"></span>
                  <p className="my-0" s>
                  {item?.impclicks?.[0].total_spent?.toFixed(2) || 0}
                  </p>
                </div></td> : null}
                {((localStorage.getItem('role') === roles.financer || localStorage.getItem('role') === roles.ops) && Headdate.startDate != null && Headdate.endDate != null) ? <><td>
                  <div>
                    <p className="my-0" s>
                    {item?.impclicks?.[0].filter_imps || 0}
                    </p>
                    <span className="block border-b border-gray-500 border-dashed"></span>
                    <p className="my-0">{item?.impclicks?.[0].filter_clicks || 0}</p>
                  </div>
                  </td>
                  <td>{item?.impclicks?.[0]?.filterSpent?.toFixed(2) || 0}</td></> : null}
                      <td>{formatDateWithTime(item.created_date)}</td>
                     {(localStorage.getItem('role')!== roles.advertiser && localStorage.getItem('role') !== roles.salesperson) && <td>
                        <p className="my-0">{item.ops_name}</p>
                        <span className="block border-b border-gray-500 border-dashed"></span>
                        <p className="my-0">{item.sales_name}</p>
                      </td>}
                      <td>
                        {item.status === 0 ? (
                          <span className="pending-badge">Pending</span>
                        ) : item.status === 1 ? (
                          <span className="processing-badge"> Running</span>
                        ) : item.status === 2 ? (
                          <span className="processing-badge"> Paused</span>
                        ) : (
                          <span className="full-badge"> Completed</span>
                        )}
                      </td>
                      {/* {localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson && (
                        <td
                          className={
                            item.verified
                              ? item.verified ===1 ? "full-badge text-center" :"pending-badge text-center"
                              : "d-flex gap-2 align-center"
                          }
                        >
                          {item.verified ? (
                            item.verified === 1 ?
                            <span>
                              Verified{" "}
                              <sl-icon name="patch-check-fill"></sl-icon>
                            </span> :<sl-tooltip content={item.rejected_reason}><span>
                              Rejected{" "}
                              <sl-icon name="x-circle-fill"></sl-icon>
                            </span></sl-tooltip> 

                          ) : localStorage.getItem("role") ===
                            roles.financer ? (
                            <div className="d-flex gap-1">
                              <SlButton
                                variant="primary"
                                onClick={() => handleVerify(item.order_id)}
                                size="small"
                              >
                                <sl-tooltip content="Verify">
                                  <span>Verify</span>
                                </sl-tooltip>
                              </SlButton>
                              <SlButton
                                variant="danger"
                                onClick={() => {
                                  setRejectReason(true);
                                  setAmid(item.order_id)
                                }}
                                size="small"
                              >
                                <sl-tooltip content="Reject">
                                  <span>Reject</span>
                                </sl-tooltip>
                              </SlButton>
                            </div>
                          ) : (
                            <span className="pending-badge">Not Verified</span>
                          )}
                        </td>
                      )} */}
                      <td>
                       <div className="d-flex gap-3 items-center">
                        
                          {item.invoice ? <sl-tooltip content="Invoice Generated">
                            <SlIcon name="check" className="text-green-500 font-bold text-lg">

                            </SlIcon> </sl-tooltip>: <sl-tooltip content="Invoice not generated"><SlIcon name="x" className="text-red-500 font-bold text-lg"></SlIcon></sl-tooltip>
                          }
                        
                          <sl-tooltip content="View Invoice">
                            <sl-icon-button
                              library="lucide"
                              name="view"
                              onClick={() => {
                               setAmid(item.order_id)
                               setShowInvoice(true)
                               setorder_status(item.status)
                               setOrderName(item.order_name)
                              }}
                            ></sl-icon-button>
                          </sl-tooltip>
                          </div>
                        
                      </td>
                      <td>
                        {item.rofile_url ? (
                          <div className="d-flex gap-3">
                            <sl-tooltip content="View Ro">
                              <sl-icon-button
                                library="lucide"
                                name="view"
                                onClick={() => {
                                  setViewPdf(true);
                                  setPdfUrl(item.rofile_url);
                                }}
                              ></sl-icon-button>
                            </sl-tooltip>
                            <sl-tooltip content="Download Ro">
                              <sl-icon-button
                                library="lucide"
                                name="download"
                                onClick={() => {
                                  downloadPdf(item.rofile_url, item.order_name);
                                }}
                              ></sl-icon-button>
                            </sl-tooltip>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      {localStorage.getItem('role') === roles.ops ? <td>
                        <div className="d-flex justify-center">{item.slot_id ? <sl-tooltip content="View">
                          <sl-icon-button
                            library="lucide"
                            name="view"
                            onClick={() => {
                              setSlotView_id(item.slot_id);
                            }}
                          ></sl-icon-button>
                        </sl-tooltip> : '-'}</div>
                      </td> : null}
                      {(localStorage.getItem("role") === roles.ops ||
                        localStorage.getItem("role") === roles.financer) && (
                        <td className="d-flex gap-2">
                          {localStorage.getItem("role") === roles.ops && (
                            <>
                              {" "}
                              <sl-tooltip content="Clone Order">
                                <sl-icon-button
                                  library="lucide"
                                  name="file"
                                  onClick={() => {
                                    handleCloneOrder(item);
                                  }}
                                ></sl-icon-button>
                              </sl-tooltip>
                              {item.status !== 3 && (
                                <sl-tooltip
                                  content={
                                    item.status === 1
                                      ? "Pause Order"
                                      : "Resume Order"
                                  }
                                >
                                  <sl-icon-button
                                    library="lucide"
                                    name={
                                      item.status === 1
                                        ? "pause-circle"
                                        : "play-circle"
                                    }
                                    onClick={() => {
                                      handleOrderOperations(item.order_id,item.status === 1 ? 1 : 2 )
                                    }}
                                  ></sl-icon-button>
                                </sl-tooltip>
                              )}
                              <sl-tooltip
                                content={
                                  item.status === 3
                                    ? "Order Completed"
                                    : "Stop Order"
                                }
                              >
                                <sl-icon-button
                                  library="lucide"
                                  name={
                                    item.status !== 3
                                      ? "stop-circle"
                                      : "clipboard-check"
                                  }
                                  onClick={() => {
                                    item.status !== 3 && handleOrderOperations(item.order_id,3)
                                    item.status !== 3 &&
                                      setOrderName(item.order_name);
                                  }}
                                ></sl-icon-button>
                              </sl-tooltip>
                           
                                <sl-tooltip content="Edit order Details">
                                  <sl-icon-button
                                    library="lucide"
                                    name="edit"
                                    onClick={() => {
                                      handleShow("edit", item);
                                      setFlag("edit");
                                      setFileUrl(item.rofile_url);
                                      setAmid(item.order_id);
                                      setOStatus(item.status)
                                      setFormikBSubFormValues(item.formikbsubformvalues)
                                    }}
                                  ></sl-icon-button>
                                </sl-tooltip>
                             
                              <sl-tooltip content="Assign order">
                                <sl-icon-button
                                  library="lucide"
                                  name="corner-up-right"
                                  onClick={() => {
                                    setAmid(item.order_id);
                                    setAssignShow(true);
                                    setAssignedAdvertisers(
                                      item.assigned_advertisers
                                    );
                                  }}
                                ></sl-icon-button>
                              </sl-tooltip>
                            </>
                          )}
                          {/* {localStorage.getItem("role") === roles.financer && (
                            <sl-tooltip content="Edit payment Details">
                              <sl-icon-button
                                library="lucide"
                                name="indian-rupee"
                                onClick={() => {
                                  setAmid(item.order_id);
                                  setShowPayment(true);
                                  setOrderName(item.order_name);
                                }}
                              ></sl-icon-button>
                            </sl-tooltip>
                          )} */}
                        {
                          localStorage.getItem('role') === roles.ops && <sl-tooltip content="View order Updates">
                          <sl-icon-button
                            library="lucide"
                            name="terminal-square"
                            onClick={()=>{
                              setAmid(item.order_id)
                              setShowLogs(true)
                            }}
                            
                          ></sl-icon-button>
                        </sl-tooltip>
                        }
                       
                          {localStorage.getItem('role') === roles.ops ? <sl-tooltip content="Order Edits">
                            <sl-icon-button
                              library="lucide"
                              name="terminal-square"
                              onClick={() => {
                               setOrderEditLogsId(item.order_id)
                              }}
                            ></sl-icon-button>
                          </sl-tooltip> : null}
                          <sl-tooltip content="View Order">
                          <SlIcon library="lucide" className = {item.push_id ? 'text-green-500' : 'text-red-500'} name="view" onClick={()=>{
                            setAmid(item.order_id)
                            setShowSalesOrder(true)
                            setSalesOrderData(item)
                          }}>

                          </SlIcon>
                        </sl-tooltip>
                        {localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.financer ?
                        <sl-tooltip-button content={localStorage.getItem("role") === roles.ops ? 'genrate payment link' : 'payment link'}>
                          <sl-icon-button library="lucide" name="link" onClick={()=>{
                            getCashfreePaymentLinks(item.order_id)
                          }}></sl-icon-button>
                        </sl-tooltip-button> : null}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="16" />
            ) : (
              <TableLoader colspan="16" />
            )}
          </table>
          {/* {document
            ?.getElementById("showScrollbar")
            ?.classList?.remove("indiana-scroll-container--hide-scrollbars")} */}
        </ScrollContainer>
      </div>
      <div className="flex justify-end">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
      <SlDrawer
        label="Order Details"
        open={show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": "50%" }}
      >
        <Stepper steps={steps} activeStep={currentStep}></Stepper>
        {currentStep === 0 ? (
          <form onSubmit={formik.handleSubmit}>
            <h3 className="text-center mb-2">Creating New Order</h3>
            <div className="mb-3">
              <label className="form-label required"> Order Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Order Name"
                aria-label=""
                name="order_name"
                value={formik.values.order_name}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {formik.errors.order_name && formik.touched.order_name ? (
                <div className="text-red-600">{formik.errors.order_name}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required">Start Date</label>
              <input
                type="date"
                name="o_start_date"
                className="form-control"
                placeholder="Choose the Start Date"
                aria-label=""
                disabled={flag === "edit" ? true : false}
                value={formik.values.o_start_date}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
                min={currentDate}
              />
              {formik.errors.o_start_date && formik.touched.o_start_date ? (
                <div className="text-red-600">{formik.errors.o_start_date}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required">End Date</label>
              <input
                type="date"
                name="o_end_date"
                className="form-control"
                placeholder="Choose End Date"
                aria-label=""
                value={formik.values.o_end_date}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
                // min={currentDate}
              />
              {formik.errors.o_end_date && formik.touched.o_end_date ? (
                <div className="text-red-600">{formik.errors.o_end_date}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required"> Company Name</label>
              <select
                className="form-select"
                aria-label="Select Company"
                name="company_id"
                placeholder="Select Company"
                onBlur={formik.handleBlur}
                disabled={flag === "edit" ? true : false}
                value={formik.values.company_id}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              >
                <option value="" key="-1">
                  Select Company
                </option>
                {company?.map((item, index) => {
                  return (
                    <option value={item.value} key={item.index}>
                      {item.label}
                    </option>
                  );
                })}
              </select>
              {formik.errors.company_id && formik.touched.company_id ? (
                <div className="text-red-600">{"Company is required!"}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required">Order Value</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Order Value"
                aria-label=""
                name="order_value"
                value={formik.values.order_value}
                onBlur={formik.handleBlur}
                disabled={disablePackage}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {formik.errors.order_value && formik.touched.order_value ? (
                <div className="text-red-600">{formik.errors.order_value}</div>
              ) : null}
            </div>
            <div className="mb-3">
              <label className="form-label required"> Payment Type</label>
              <select
                className="form-select"
                aria-label="Select payment type"
                name="payment_type"
                placeholder="Select Payment Type"
                onBlur={formik.handleBlur}
                value={formik.values.payment_type}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              >
                <option value={0} key="-1">
                  Select Payment Type
                </option>
                {/* <option value={1}>Prepaid</option>
                <option value={2}>Postpaid</option>
                <option value={3}>Partially Paid</option> */}
                {slotPaymentTypeOptions.map(item => <option value={item.value}>{item.label}</option>)}
              </select>
              {formik.errors.payment_type && formik.touched.payment_type ? (
                <div className="text-red-600">{formik.errors.payment_type}</div>
              ) : null}
            </div>
            {formik.values.payment_type === "1" || formik.values.payment_type === "3" || formik.values.payment_type === "4"? (
              <>
              <div className="mb-3">
                <label className="form-label">Cheque No / UPI ID.</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Transcation."
                  aria-label=""
                  name="cheque_no"
                  value={formik.values.cheque_no}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
                {formik.errors.cheque_no && formik.touched.cheque_no ? (
                  <div className="text-red-600">{formik.errors.cheque_no}</div>
                ) : null}
              </div>
              <div className="mb-3">
              <label className="form-label">Amount</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Amount."
                  aria-label=""
                  name="amount"
                  value={formik.values.amount}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
                {formik.errors.amount && formik.touched.amount ? (
                  <div className="text-red-600">{formik.errors.amount}</div>
                ) : null}
              </div>
              </>
            ) : null} 
            <div className="mb-3">
              <label className="form-label">Ro No</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter RO Number"
                aria-label=""
                name="ro_no"
                value={formik.values.ro_no}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {formik.errors.ro_no && formik.touched.ro_no ? (
                <div className="text-red-600">{formik.errors.ro_no}</div>
              ) : null}
            </div>
            <div className="mb-3">
              <label className="form-label">Ro File</label>
              <div className="d-flex gap-3">
                <input
                  type="file"
                  className="form-control"
                  aria-label=""
                  name="ro_File"
                  id="ro_file"
                  accept="application/pdf"
                  onChange={(e) => {
                    handleFileChange(e,'ro_File');
                  }}
                />

                {progress > 0 && progress < 100 ? (
                  <SlProgressBar value={progress}>{progress}%</SlProgressBar>
                ) : fileUrl ? (
                  <sl-icon-button
                    title="View RO"
                    library="lucide"
                    name="view"
                    onClick={() => {
                      setViewPdf(true);
                      setPdfUrl(fileUrl);
                    }}
                  ></sl-icon-button>
                ) : (
                  flag === "edit" &&
                  formik.values.rofile_url && (
                    <sl-icon-button
                      title="View RO"
                      library="lucide"
                      name="view"
                      onClick={() => {
                        setViewPdf(true);
                        setPdfUrl(formik.values.rofile_url);
                      }}
                    ></sl-icon-button>
                  )
                )}
              </div>
              <p>{formik.values.rofile_url || fileUrl || "-"}</p>
              {formik.errors.rofile_url && (
                <p className="text-red-600">{formik.errors.rofile_url}</p>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">SDC File</label>
              <div className="d-flex gap-3">
                <input
                  type="file"
                  className="form-control"
                  aria-label=""
                  name="sdc_file"
                  id="sdc_file"
                  accept="application/pdf"
                  onChange={(e) => {
                    handleFileChange(e, 'sdc_file');
                  }}
                />

                {progress1 > 0 && progress1 < 100 ? (
                  <SlProgressBar value={progress1}>{progress1}%</SlProgressBar>
                ) : fileUrl1 ? (
                  <sl-icon-button
                    title="View SDC"
                    library="lucide"
                    name="view"
                    onClick={() => {
                      setViewPdf(true);
                      setPdfUrl(fileUrl1);
                    }}
                  ></sl-icon-button>
                ) : (
                  flag === "edit" &&
                  formik.values.sdcfile_url && (
                    <sl-icon-button
                      title="View RO"
                      library="lucide"
                      name="view"
                      onClick={() => {
                        setViewPdf(true);
                        setPdfUrl(formik.values.sdcfile_url);
                      }}
                    ></sl-icon-button>
                  )
                )}
              </div>
              <p>{formik.values.sdcfile_url || fileUrl1 || "-"}</p>
              {formik.errors.sdcfile_url && (
                <p className="text-red-600">{formik.errors.sdcfile_url}</p>
              )}
            </div>
            <div slot="footer">
              <SlButton type="submit" variant="primary" size="medium">
                Next
              </SlButton>
            </div>
          </form>
        ) : (
          <form onSubmit={formik1.handleSubmit}>
            <h4 className="text-center mt-2"> Sales Details</h4>
            <div className="mb-4">
              <label htmlFor="" className="form-label font-medium">
                Sales Person Name
              </label>
              <b className="text-red-600">*</b>
              <Select
                // class="form-select"
                aria-label="Default select example"
                name="sales_id"
                placeholder="select sales person name"
                onBlur={formik1.handleBlur}
                value={defaultValue(salesList, formik1.values.sales_id)}
                isDisabled={disablePackage}
                onChange={(selected) => {
                  if(selectedSalesType == "alpha")
                  {
                    let userType = salesList.filter(item => item.value === selected.value)
                    if(userType != "alpha")
                    {
                      setPackageValue(0);
                      setPackageDetails((prev) => ({...prev,package_type:'',creative_type:''}))
                    }
                  }
                  formik1.setFieldValue("sales_id", selected.value);
                  setSelectedSalesId(selected.value)
                  formik1.setFieldValue("split_sales_id", 0);
                }}
                options={salesList}
              ></Select>
              {formik1.errors.sales_id && formik1.touched.sales_id ? (
                <div className="text-red-600">{formik1.errors.sales_id}</div>
              ) : null}
            </div>
            <div className="ind">
                    <h6>
                      Brand 
                    </h6>
                    <Select
                      // class="form-select"
                      aria-label="Default select example"
                      name="brand_id"
                      placeholder="Select a Brand"
                      onBlur={formik1.handleBlur}
                      value={
                        defaultValue(assignedBrands, formik1.values.brand_id) ||
                        null
                      }
                      onChange={(selected) =>
                        formik1.setFieldValue("brand_id", selected.value)
                      }
                      options={assignedBrands}
                      classNamePrefix="select"
                    />
                    {formik1.touched.brand_id && formik1.errors.brand_id && (
                      <span id="formikError" className="text-red-500 text-xs">
                        {formik1.errors.brand_id}
                      </span>
                    )}
                  </div>

            {
              <div className="row mb-3 align-items-start d-flex">
                <div className="col-6">
                  <label htmlFor="" className="form-label font-medium">
                    Split Sales Person
                  </label>
                  <Select
                    // class="form-select"
                    aria-label="Default select example"
                    name="split_sales_id"
                    placeholder="select sales person"
                    onBlur={formik1.handleBlur}
                    value={defaultValue(
                      salesList,
                      formik1.values.split_sales_id
                    )}
                    onChange={(selected) => {
                      formik1.setFieldValue("split_sales_id", selected.value);
                      formik1.setFieldValue("split_sales_percent", 0);
                    }}
                    options={[
                      { label: "None", value: 0 },
                      ...salesList.filter(
                        (item) => +item.value !== +formik1.values.sales_id
                      ),
                    ]}
                  ></Select>
                  {formik1.errors.split_sales_id &&
                  formik1.touched.split_sales_id ? (
                    <div className="text-red-600">
                      {formik1.errors.split_sales_id}
                    </div>
                  ) : null}
                </div>
                {formik1.values.split_sales_id ? (
                  <div
                    className="col-6"
                    style={{ "margin-block-start": "auto" }}
                  >
                    <label htmlFor="" className="form-label font-medium">
                      Split percentage
                    </label>
                    <span className="text-red-600">*</span>
                    <div className="d-flex">
                      <input
                        type="number"
                        className="form-control"
                        id=""
                        placeholder="Enter Split percentage"
                        onBlur={formik1.handleBlur}
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                        value={formik1.values.split_sales_percent}
                        name="split_sales_percent"
                      />
                      <span className="ml-1 mt-5">
                        <b>%</b>
                      </span>
                    </div>
                    {formik1.errors.split_sales_percent &&
                    formik1.touched.split_sales_percent ? (
                      <div className="text-red-600">
                        {formik1.errors.split_sales_percent}
                      </div>
                    ) : null}
                  </div>
                ) : null}
                 <div className="col d-flex items-center gap-2 mb-3">
                      <input type="checkbox"  aria-label="" name="internal" id="internal"
                        checked={formik1.values.internal}
                        onBlur={formik1.handleBlur}
                        onChange={formik1.handleChange}
                      />
                      <label for="internal" className=""> Internal Order</label>
                      {formik1.errors.internal && formik1.touched.internal ? <div className="text-red-600">{formik1.errors.internal}</div> : null} 
                    </div>
                    <div className="col d-flex items-center gap-2 mb-3">
                      <input type="checkbox"  aria-label="" name="gst" id="gst"
                        checked={formik1.values.gst}
                        onBlur={formik1.handleBlur}
                        onChange={formik1.handleChange}
                      />
                      <label for="gst" className=""> Including GST</label>
                      {formik1.errors.gst && formik1.touched.gst ? <div className="text-red-600">{formik1.errors.gst}</div> : null} 
                    </div>
               
              </div>
            }
                <div className="col d-flex flex-column gap-2 mb-3">
                  <label className="form-label mb-1">Is package</label>

                  <div className="flex items-center gap-3">
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="package_order"
                        value={0}
                        checked={+formik1.values.package_order === 0}
                        onChange={formik1.handleChange}
                        onBlur={formik1.handleBlur}
                        disabled={disablePackage || disablePackgeCreation}
                      />
                      No Package
                    </label>

                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="package_order"
                        value={1}
                        checked={+formik1.values.package_order === 1}
                        onChange={formik1.handleChange}
                        onBlur={formik1.handleBlur}
                        disabled={disablePackage || disablePackgeCreation}
                      />
                      Package
                    </label>

                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="package_order"
                        value={2}
                        checked={+formik1.values.package_order === 2}
                        onChange={formik1.handleChange}
                        onBlur={formik1.handleBlur}
                        disabled={disablePackage || disablePackgeCreation}
                      />
                      Zone Package
                    </label>
                  </div>

                  {formik1.errors.package_order && formik1.touched.package_order && (
                    <div className="text-red-600 mt-1">
                      {formik1.errors.package_order}
                    </div>
                  )}
                </div>

                {+formik1.values.package_order === 1  ? <PackageOrder packageValue={packageValue} setPackageValue={setPackageValue} setPackageDetails={setPackageDetails} packageDetails={packageDetails} disable={disablePackage}  salesType={selectedSalesType} updatedPackageValue={updatedPackageValue} setUpdatedPackageValue={setUpdatedPackageValue}/> : +formik1.values.package_order === 2 ? <ZonePacakge packageValue={packageValue} setPackageValue={setPackageValue} setPackageDetails={setPackageDetails} packageDetails={packageDetails} disable={disablePackage}  salesType={selectedSalesType} updatedPackageValue={updatedPackageValue} setUpdatedPackageValue={setUpdatedPackageValue} flag={flag}/> : 
                <>{formikBSubFormValues?.map((subFormValue, index) => {
                  return (
                    <div className="mainbox relative">
                      <OrderDetails
                        index={index}
                        nextClicked={formikBTouchedFlag}
                        saveChanges={formikBSaveFlag}
                        formikBSubFormValues={formikBSubFormValues}
                        setFormikBSubFormValues={setFormikBSubFormValues}
                        formikBSubFormErrors={formikBSubFormErrors}
                        setFormikBSubFormErrors={setFormikBSubFormErrors}
                        editData={
                          Object.keys(subFormValue).length ? subFormValue : null
                        }
                      />
                      {formikBSubFormValues.length !== 1 ? (
                        <div className="text-danger absolute top-2 right-2">
                          <sl-icon
                            library="lucide"
                            name="x-circle"
                            type="button"
                            size="large"
                            aria-hidden="true"
                            onClick={async () => {
                              await setFormikBSaveFlag(!formikBSaveFlag);
                              let tempAllFormValues = JSON.parse(
                                JSON.stringify(formikBSubFormValues)
                              );
                              let tempAllFormErrors = JSON.parse(
                                JSON.stringify(formikBSubFormErrors)
                              );
                              tempAllFormValues = tempAllFormValues.filter(
                                (item, itemIndex) => itemIndex !== index
                              );
                              tempAllFormErrors = tempAllFormErrors.filter(
                                (item, itemIndex) => itemIndex !== index
                              );
                              setFormikBSubFormValues([...tempAllFormValues]); // Ensure a new reference
                              setFormikBSubFormErrors([...tempAllFormErrors]);
                            }}
                          ></sl-icon>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
                <div className="w-full my-1 flex justify-end">
                  <button
                    type="button"
                    className="bg-blue-500 text-white hover:bg-blue-600 !flex gap-2 text-xs px-2 py-1 items-center rounded-md font-bold"
                    onClick={() => {
                      setFormikBSaveFlag(!formikBSaveFlag);

                      setFormikBSubFormValues([
                        ...formikBSubFormValues,
                        {
                          ...subFormInitialValues,
                          internal_id:
                            0,
                        },
                      ]);
                    }}
                  >
                   <span>Add Unit</span><img src={addIcon} alt="submit" />
                  </button>
                  </div>
                </> 
                }
            <div className="d-flex justify-between mt-2">
              <SlButton
                type="SlButton"
                onClick={() => setCurrentStep((prevStep) => prevStep - 1)}
                variant="primary"
                size="medium"
              >
                prev
              </SlButton>
              <SlButton disabled={formik1.isSubmitting} type="submit" variant="primary" size="medium" onClick={()=>{setFormikBTouched(true)}}>
               {formik1.isSubmitting ?  'Submitting' : 'Submit'}
              </SlButton>
            </div>
          </form>
        )}
      </SlDrawer>
      <SlDrawer
        label="Rejecting order"
        open={rejectReason}
        style={{ "--size": "25vw" }}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          setRejectReason(false);
          setAmid("")
          formik3.resetForm()
        }}
      >
        <form onSubmit={formik3.handleSubmit}>
        <div className="form-group">
          <label className="form-label my-2">Rejected Reason</label>
          <textarea className="form-control mb-2" name="reason" placeholder="Enter Reason" onChange={formik3.handleChange} onBlur={formik3.handleBlur}></textarea>
          {
            (formik3.errors && formik3.touched.reason )? <p className="text-red-600 my-1">{ formik3.errors.reason}</p> : null
          }
          <button type="submit" className="btn btn-danger d-flex flex-grow-1">Reject</button>
        </div>
        </form>
      </SlDrawer>



      {/* {showLineItem ? (
        <AddLineItem
          show={showLineItem}
          setShow={handleLineItem}
          order_id={amid}
          salesType={salesType}
          orderName={orderName}
          company={companyId}
          impressionData={impressionData}
          permissions={advertiserOrderPermissions}
        />
      ) : null} */}
      {headViewData && Object.keys(headViewData).length > 0 && (
        <SlDrawer
          label={`Detailed View of ${headViewMonthFlag}`}
          open={Object.keys(headViewData).length > 0}
          onSlAfterHide={() => {
            setHeadViewData({});
            setHeadViewMonthFlag("");
          }}
        >
          <div className="overflow-x-auto">
            {headViewData.headData?.length ? (
              <>
                <h2>Heads</h2>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <td>Name</td>
                      <td>I/O RECEIVED</td>
                      <td>DELIVERED</td>
                      <td>TARGET</td>
                      <td>ACHIEVED</td>
                      <td>RANK</td>
                      <td>ORDERS</td>
                      <td>AVG</td>
                    </tr>
                  </thead>
                  {headViewData.headData?.length ? (
                    <tbody>
                      {headViewData.headData?.map((item) => {
                        return (
                          <tr>
                            <td>{capitalizeFirstLetter(item.value.name)}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthRoCPD
                            )}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.delivered
                            )}`}</td>
                            <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthAchieved
                            )}`}</td>
                            <td>{item.value.rank}</td>
                            <td>{item.value.campaignCount}</td>
                            <td>{item.value.monthAvg}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <NoDataFound></NoDataFound>
                  )}
                </table>
              </>
            ) : null}
            {headViewData.nationRegionHeadsData?.length ? (
              <>
                <h2>National Region Heads</h2>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <td>Name</td>
                      <td>I/O RECEIVED</td>
                      <td>DELIVERED</td>
                      <td>TARGET</td>
                      <td>ACHIEVED</td>
                      <td>RANK</td>
                      <td>ORDERS</td>
                      <td>AVG</td>
                    </tr>
                  </thead>
                  {headViewData.nationRegionHeadsData?.length ? (
                    <tbody>
                      {headViewData.nationRegionHeadsData?.map((item) => {
                        return (
                          <tr>
                            <td>{capitalizeFirstLetter(item.value.name)}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthRoCPD
                            )}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.delivered
                            )}`}</td>
                            <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthAchieved
                            )}`}</td>
                            <td>{item.value.rank}</td>
                            <td>{item.value.campaignCount}</td>
                            <td>{item.value.monthAvg}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <NoDataFound></NoDataFound>
                  )}
                </table>
              </>
            ) : null}
            {headViewData.nationRegularData?.length ? (
              <>
                <h2>National Sales</h2>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <td>Name</td>
                      <td>I/O RECEIVED</td>
                      <td>DELIVERED</td>
                      <td>TARGET</td>
                      <td>ACHIEVED</td>
                      <td>RANK</td>
                      <td>ORDERS</td>
                      <td>AVG</td>
                    </tr>
                  </thead>
                  {headViewData.nationRegularData?.length ? (
                    <tbody>
                      {headViewData.nationRegularData?.map((item) => {
                        return (
                          <tr>
                            <td>{capitalizeFirstLetter(item.value.name)}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthRoCPD
                            )}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.delivered
                            )}`}</td>
                            <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthAchieved
                            )}`}</td>
                            <td>{item.value.rank}</td>
                            <td>{item.value.campaignCount}</td>
                            <td>{item.value.monthAvg}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <NoDataFound></NoDataFound>
                  )}
                </table>
              </>
            ) : null}
            {headViewData.localRegularData?.length ? (
              <>
                <h2>Local Sales</h2>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <td>Name</td>
                      <td>I/O RECEIVED</td>
                      <td>DELIVERED</td>
                      <td>TARGET</td>
                      <td>ACHIEVED</td>
                      <td>RANK</td>
                      <td>ORDERS</td>
                      <td>AVG</td>
                    </tr>
                  </thead>
                  {headViewData.localRegularData?.length ? (
                    <tbody>
                      {headViewData.localRegularData?.map((item) => {
                        return (
                          <tr>
                            <td>{capitalizeFirstLetter(item.value.name)}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthRoCPD
                            )}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.delivered
                            )}`}</td>
                            <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                            <td>{`₹${formatSpentValue(
                              item.value.monthAchieved
                            )}`}</td>
                            <td>{item.value.rank}</td>
                            <td>{item.value.campaignCount}</td>
                            <td>{item.value.monthAvg}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <NoDataFound></NoDataFound>
                  )}
                </table>
              </>
            ) : null}
          </div>
        </SlDrawer>
      )}
      {viewPdf && (
        <PdfViewer url={pdfUrl} show={viewPdf} setShow={setViewPdf} />
      )}
      {showCompany && (
        <CompanyDetails
          company_id={companyId}
          show={showCompany}
          setShow={setShowCompany}
        />
      )}
      {assignShow && (
        <AssignOrder
          order_id={amid}
          show={assignShow}
          setShow={setAssignShow}
          loadData={loadData}
          currentPage={currentPage}
          search={search}
          assignedAdvertisers={assignedAdvertisers}
          setAssignedAdvertisers={setAssignedAdvertisers}
        />
      )}
      {
        showInvoice &&(
          <InvoiceUpdate show={showInvoice} setShow={setShowInvoice} order_id = {amid} order_status= {order_status} order_name={orderName}/>
        )
      }
      {
        showLogs && (<OrderLogs show={showLogs} setShow={setShowLogs} setOrderId={setAmid} order_id={amid} />)
      }
      {showFilter && <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <div className="ml-auto flex align-items-end gap-3 flex-wrap-reverse">
        <div className="d-flex gap-2.5 flex-wrap invoice-radios-list ">
                <div class="custom-invoice-radio">
                  <input
                    type="radio"
                    id="ide1"
                    value={'all'}
                    name="invoice"
                    onClick={()=>{
                      setInvoiceStatus("all")
                    }}
                    checked={invoiceStatus === "all"}
                  />
                  <label for="ide1" className="rounded-full">
                    <span>{`All`}</span>
                  </label>
                </div>
                <div class="custom-invoice-radio">
                  <input
                    type="radio"
                    id="ide2"
                    name="invoice"
                    value={"0"}
                    onChange={()=>{
                      setInvoiceStatus("0")
                    }}
                    checked={invoiceStatus === "0"}

                  />
                  <label for="ide2" className="rounded-full">
                    <span>{`No Invoice ${getCountByInvoiceStatus(false)}`}</span>
                  </label>
                </div>
                <div class="custom-invoice-radio">
                  <input
                    type="radio"
                    id="ide3"
                    name="invoice"
                    value={'1'}
                    onChange={()=>{
                      setInvoiceStatus("1")
                    }}
                    checked={invoiceStatus === "1"}
                  />
                  <label for="ide3" className="rounded-full">
                    <span>{`Invoice ${getCountByInvoiceStatus(true)}`}</span>
                  </label>
                </div>
               
              </div>
              <div className="d-flex gap-2.5 flex-wrap payment-radios">
              <div class="custom-invoice-radio">
             <input
               type="radio"
               id="ide1"
               name="invoice-status"
               value={'all'}
               onChange={()=>{
                 setPaymentStatus("all")
               }}
               checked={paymentStatus === "all"}

             />
             <label for="ide1" className="rounded-full">
               <span>{`All`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               id="ide1"
               name="invoice-status"
               value={'0'}
               onChange={()=>{
                 setPaymentStatus("0")
               }}
               checked={paymentStatus === "0"}

             />
             <label for="ide1" className="rounded-full">
               <span>{`Pending ${getCountByPaymentStatus(0)}`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               name="invoice-status"
               id="ide2"
               value={'1'}
               onChange={() =>{
                 setPaymentStatus("1")
               }}
               checked={paymentStatus === "1"}

             />
             <label for="ide2" className="rounded-full">
               <span>{`Partially Paid ${getCountByPaymentStatus(1)}`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               name="invoice-status"
               id="ide3"
               value={'2'}
               onChange={
                () =>{
                   setPaymentStatus("2")
               }
              }
               checked={paymentStatus === "2"}

             />
             <label for="ide3" className="rounded-full">
               <span>{`Finished ${getCountByPaymentStatus(2)}`}</span>
             </label>
           </div>
           <div class="custom-invoice-radio">
             <input
               type="radio"
               name="invoice-status"
               id="ide4"
               value={'3'}
               onChange={()=>{
                   setPaymentStatus("3")
               }}
               checked={paymentStatus === "3"}

             />
             <label for="ide4" className="rounded-full">
               <span>{`Settlement ${getCountByPaymentStatus(3)}`}</span>
             </label>
           </div>
         </div>
          <div className="w-full">
            <SlSelect
              label="Ro"
              size="medium"
              value={roStatus}
              className="w-full"
              onSlChange={handleRoStatus}
            >
              <SlIcon library="lucide" name="file" slot="prefix"></SlIcon>
              <SlOption key="all" value="all">
                All
              </SlOption>
              <SlOption key="1" value="1">
                Ro
              </SlOption>
              <SlOption key="0" value="0">
                No Ro
              </SlOption>
            </SlSelect>
          </div>
          
          <div className="w-full">
            <SlInput
              label="Search"
              size="medium"
              className="w-full"
              id="myInput"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search by Order Name/Company"
            >
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
          </div>
          
        </div>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>}
      {slotView_id ? (
        <SlotVIew slot_id={slotView_id} setSlot_id={setSlotView_id} />
      ) : null}
      {orderEditLogsId ? (
        <OrderEditLogs order_id={orderEditLogsId} setOrder_id={setOrderEditLogsId} />
      ) : null}
      {showSalesOrder ? (<OrderPdf show={showSalesOrder} setShow={setShowSalesOrder} orderData={salesOrderData} setOrderData={setSalesOrderData}/>) : null}
      {<SlDrawer
  open={Object.keys(cashfreePaymentLinkDetails).length > 0}
  onSlRequestClose={() => setCashfreePaymentLinkDetails({})}
  style={{ "--size": "fit-content" }}
>
  <h3>Payment details of {cashfreePaymentLinkDetails.order_id}</h3>
  <hr />

  {cashfreePaymentLinkDetails.loading ? (
    <TableLoader />
  ) : (
    <div className="d-flex gap-2.5 flex-wrap">
      <div className="w-full">

        {/* ==== TABLE LIST ==== */}
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.NO</th>
              <th>Link Id</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Purpose</th>
              <th>Link URL</th>
              <th>Created By</th>
              <th>Customer Name</th>
              <th>Customer Email</th>
              <th>Customer Phone</th>
              <th>Created At</th>
              {/* {localStorage.getItem("role") === roles.ops && <th>Actions</th>} */}
            </tr>
          </thead>

          <tbody>
            {cashfreePaymentLinkDetails.paymentArray?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.link_id}</td>
                <td>{item.link_status || "-"}</td>
                <td>{item.link_amount || "-"}</td>
                <td>{item.link_purpose || "-"}</td>
                <td>{item.link_url || "-"}</td>
                <td>{item.created_by_name || "-"}</td>
                <td>{item.customer_name || "-"}</td>
                <td>{item.customer_email || "-"}</td>
                <td>{item.customer_phone || "-"}</td>
                <td>{formatDateToReadable(item?.created_on) || "-"}</td>
                {/* {localStorage.getItem("role") === roles.ops && (
                  <td>
                    <SlButton
                      variant="danger"
                      size="small"
                      className="cursor-pointer"
                      onClick={() =>
                        deleteOrderPaymentLink(item.opd_id, item.order_id)
                      }
                    >
                      Delete
                    </SlButton>
                  </td>
                )} */}
              </tr>
            ))}

            {cashfreePaymentLinkDetails.paymentArray?.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center">No data found</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="d-flex gap-2.5 flex-wrap">
        <AsyncSelect type="text"
            className="w-[50%]"
            name="cashfree_link_id"
            placeholder='Select Cashfree Link Id'                      
            value={paymentLinkIdOptions.find(item => item.value === addCashfreePaymentLinkId)}
            onChange={selected => { setAddCashfreePaymentLinkId(selected.value);}}
            loadOptions={debouncedFetchCashfreeLinkIdOptions}
            noOptionsMessage={() => "Type searching Link Id"}

            />
              <SlButton onClick={() => {
                addCashfreePaymentLink(addCashfreePaymentLinkId, cashfreePaymentLinkDetails.order_id)
              }}
                disabled={!addCashfreePaymentLinkId || !cashfreePaymentLinkDetails.order_id}
              >
                Add Payment Link
              </SlButton>
        </div>
      </div>
    </div>
  )}
</SlDrawer>

}
{showMultiOrder && <MultiOrder open={showMultiOrder} loadOrders={loadOrdersFromMulti} companies={company} sales={salesList}/>}
    </>
  );
}

export default Order;
